// src/api/regions-api.js
import { gql } from '@apollo/client';
import client from './apollo-client';

// GraphQL Queries
export const GET_REGIONS = gql`
  query GetRegions {
    regions {
      id
      nomRegion
      createdAt
      updatedAt
      villeVillages {
        id
        nomVilleVillage
      }
      users {
        id
      }
      pharmacies {
        id
      }
    }
  }
`;

export const GET_REGION = gql`
  query GetRegion($id: ID!) {
    region(id: $id) {
      id
      nomRegion
      createdAt
      updatedAt
      villeVillages {
        id
        nomVilleVillage
      }
      users {
        id
        email
        firstName
        lastName
      }
      pharmacies {
        id
        namePharmacy
        telPharmacy
      }
    }
  }
`;

export const GET_VILLES_BY_REGION = gql`
  query GetVillesByRegion($regionId: ID!) {
    villesByRegion(regionId: $regionId) {
      id
      nomVilleVillage
      regionId
      createdAt
      updatedAt
    }
  }
`;

export const GET_ALL_VILLES = gql`
  query GetAllVilles {
    villes {
      id
      nomVilleVillage
      regionId
      region {
        id
        nomRegion
      }
      createdAt
      updatedAt
    }
  }
`;

// GraphQL Mutations
export const CREATE_REGION = gql`
  mutation CreateRegion($createRegionInput: CreateRegionInput!) {
    createRegion(createRegionInput: $createRegionInput) {
      id
      nomRegion
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_REGION = gql`
  mutation UpdateRegion($updateRegionInput: UpdateRegionInput!) {
    updateRegion(updateRegionInput: $updateRegionInput) {
      id
      nomRegion
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_REGION = gql`
  mutation DeleteRegion($id: ID!) {
    removeRegion(id: $id)
  }
`;

export const CREATE_VILLE = gql`
  mutation CreateVille($createVilleInput: CreateVilleInput!) {
    createVille(createVilleInput: $createVilleInput) {
      id
      nomVilleVillage
      regionId
      region {
        id
        nomRegion
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_VILLE = gql`
  mutation UpdateVille($updateVilleInput: UpdateVilleInput!) {
    updateVille(updateVilleInput: $updateVilleInput) {
      id
      nomVilleVillage
      regionId
      region {
        id
        nomRegion
      }
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_VILLE = gql`
  mutation DeleteVille($id: ID!) {
    removeVille(id: $id)
  }
`;

// Regions API functions
export const regionsApi = {
  // Regions
  getRegions: async () => {
    try {
      const { data } = await client.query({
        query: GET_REGIONS,
        fetchPolicy: 'network-only'
      });
      return data.regions;
    } catch (error) {
      console.error('Get regions error:', error);
      throw error;
    }
  },

  getRegion: async (id) => {
    try {
      const { data } = await client.query({
        query: GET_REGION,
        variables: { id },
        fetchPolicy: 'network-only'
      });
      return data.region;
    } catch (error) {
      console.error(`Get region ${id} error:`, error);
      throw error;
    }
  },

  createRegion: async (regionData) => {
    try {
      const { data } = await client.mutate({
        mutation: CREATE_REGION,
        variables: { createRegionInput: regionData }
      });
      return data.createRegion;
    } catch (error) {
      console.error('Create region error:', error);
      throw error;
    }
  },

  updateRegion: async (regionData) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_REGION,
        variables: { updateRegionInput: regionData }
      });
      return data.updateRegion;
    } catch (error) {
      console.error(`Update region ${regionData.id} error:`, error);
      throw error;
    }
  },

  deleteRegion: async (id) => {
    try {
      const { data } = await client.mutate({
        mutation: DELETE_REGION,
        variables: { id }
      });
      return data.removeRegion;
    } catch (error) {
      console.error(`Delete region ${id} error:`, error);
      throw error;
    }
  },

  // Villes
  getVillesByRegion: async (regionId) => {
    try {
      const { data } = await client.query({
        query: GET_VILLES_BY_REGION,
        variables: { regionId },
        fetchPolicy: 'network-only'
      });
      return data.villesByRegion;
    } catch (error) {
      console.error(`Get villes by region ${regionId} error:`, error);
      throw error;
    }
  },

  getAllVilles: async () => {
    try {
      const { data } = await client.query({
        query: GET_ALL_VILLES,
        fetchPolicy: 'network-only'
      });
      return data.villes;
    } catch (error) {
      console.error('Get all villes error:', error);
      throw error;
    }
  },

  createVille: async (villeData) => {
    try {
      const { data } = await client.mutate({
        mutation: CREATE_VILLE,
        variables: { createVilleInput: villeData }
      });
      return data.createVille;
    } catch (error) {
      console.error('Create ville error:', error);
      throw error;
    }
  },

  updateVille: async (villeData) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_VILLE,
        variables: { updateVilleInput: villeData }
      });
      return data.updateVille;
    } catch (error) {
      console.error(`Update ville ${villeData.id} error:`, error);
      throw error;
    }
  },

  deleteVille: async (id) => {
    try {
      const { data } = await client.mutate({
        mutation: DELETE_VILLE,
        variables: { id }
      });
      return data.removeVille;
    } catch (error) {
      console.error(`Delete ville ${id} error:`, error);
      throw error;
    }
  }
};